import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CultureCodes, CurrencyCodes } from '../../../../Autofacets-Core/src/app/utils/enums';

@Injectable({
  providedIn: 'root'
})
export class UtilityServices {

  pageNotFoundMessage:string;
  constructor(
    private router: Router
  ) { }

  public isNumber(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public getLocalStorage(key: string): any {
    if (localStorage.getItem(key) != null) {
      return JSON.parse(localStorage.getItem(key));
    }
  }

  public getLocalStorageArrayKeyDetails(key: string, screenName: string): any {
    if (localStorage.getItem(key) != null) {
      const data = JSON.parse(localStorage.getItem(key));
      return data.filter(x => x.ScreenName === screenName);
    }
  }

  public getLocalStorageitem(key: string): any {
    if (localStorage.getItem(key) != null) {
      return localStorage.getItem(key);
    }
  }

  public setLocalStorage(key: string, data: any): void {
    if (typeof (data) === 'object') {
      localStorage.setItem(key, JSON.stringify(data));
    } else {
      localStorage.setItem(key, data);
    }
  }

  public removeLocalStorage(key: string[]): boolean {
    key.forEach(element => {
      localStorage.removeItem(element);
    });
    return true;
  }

  public clearLocalStorage(): boolean {
    localStorage.clear();
    return true;
  }

  public navigateToNext(url: string) {
    const myurl = `${url}`;
    this.router.navigateByUrl(myurl).then(_e => {
      // This is intentional
    });
  }

  public readDataFromStringUrl(url: string) {
    const myArray = [];
    const myObj = [];
    const qData = decodeURIComponent(url).split('?');

    const ampData = qData[1].split('&');
    ampData.forEach(element => {
      myArray.push(element.split('='));
    });
    for (let value of myArray) {
      let temp = {};
      temp[value[0]] = value[1];
      myObj.push(temp);
    }
    return myObj;
  }

  getCurrencyCode(cultureCode: string): string {
    let code = '';
    switch (cultureCode) {
      case CultureCodes.EN_US:
        code = CurrencyCodes.USD;
        break;
      case CultureCodes.NL_NL:
        code = CurrencyCodes.EUR;
        break;
      case CultureCodes.NB_NO:
        code = CurrencyCodes.NOK;
        break;
      case  CultureCodes.FI_FI:
        code = CurrencyCodes.EUR;
        break;
      case CultureCodes.DE_DE:
        code = CurrencyCodes.EUR;
        break;
      default:
        code = CurrencyCodes.USD;
    }
    return code;
  }
}
